import { cmsCLient } from '@/services/axiosConfig'
import { GetServiceCategories, GetServiceList, GetSingleService } from './types'

export const getServiceCategories: GetServiceCategories = async () => {
  try {
    return (await cmsCLient.get('/service-categories')).data
  } catch (e: any) {
    return e.message
  }
}
export const getServiceList: GetServiceList = async (id) => {
  try {
    return (await cmsCLient.get('/mobile-service/' + id.toString())).data
  } catch (e: any) {
    return e.message
  }
}
export const getSingleService: GetSingleService = async (id) => {
  try {
    return (await cmsCLient.get('/mobile-service/single/' + id.toString())).data
  } catch (e: any) {
    return e.message
  }
}
